module.exports = __webpack_public_path__ + "static/media/Logo Database.99237ea1.svg";